<template>
    <div id="auth" class="container-fluid">
        <div class="row align-items-center justify-content-center">
            <div class="col-sm-4">
                <div class="alert alert-info" v-if="$route.query.continue == 'true'">Please login to continue</div>
                
                <form @submit.prevent="login" class="form">
                    <h1>Login</h1>
                    <b-form-group>
                        <b-form-input v-model.trim.lazy="$v.authData.username.$model" :class="{ 'is-invalid': $v.authData.username.$error }" placeholder="Enter your email address"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.username.$error">Please enter a valid email address</div>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input type="password" v-model.trim.lazy="$v.authData.password.$model" :class="{ 'is-invalid': $v.authData.password.$error }" placeholder="Enter your password"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.password.$error">Password cannot be blank</div>
                        
                        <better-link class="float-right" :to="forgotPasswordLink">Forgot Password?</better-link>
                    </b-form-group>
                    
                    <div class="alert alert-danger" v-if="status == 'error'">{{ errorMessage }}</div>
                    
                    <SubmitButton title="Log In" :is-disabled="$v.$invalid || !$v.$anyDirty" :is-saving="isSaving" class="mr-3" /> Need an account? <better-link :to="{path: '/register', query: $route.query}">Register</better-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SubmitButton from '@/components/form-controls/SubmitButton'

import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import email from 'vuelidate/lib/validators/email'

export default {
    name: 'Login',
    mixins: [
        validationMixin
    ],
    components: {
        SubmitButton,
    },
    head: {
        title() {
            return {
                inner: 'Log In',
            }
        },
    },
    validations: {
        authData: {
            username: {
                required,
                email,
            },
            password: {
                required,
            },
        },
    },
    data() {
        return {
            authData: {
                username: '',
                password: '',
            },
        }
    },
    computed: {
        ...mapState('account', ['status', 'errorMessage']),
        isSaving() {
            return this.status == 'in progress'
        },
        forgotPasswordLink() {
            if (required(this.authData.username) && email(this.authData.username)) {
                return '/forgot-password?email='+this.authData.username
            } else {
                return '/forgot-password'
            }
        },
    },
    methods: {
        login() {
            this.$store.dispatch('account/login', this.authData)
        },
    },
    created() {
        this.unsubscribe = this.$store.subscribe(mutation => {
            if (mutation.type === 'account/setCurrentUserProfile') {
                this.isSaving = false
            }
        });
    },
    activated() {
        this.$emit('updateHead')
    },
    beforeDestroy() {
        this.unsubscribe()
    },
};
</script>